<template>
  <aside class="main-sidebar">

    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar Menu -->
      <sidebar-menu />
      <!-- /.sidebar-menu -->
    </section>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
import SidebarMenu from './SidebarMenu'

export default {
  name: 'Sidebar',
  components: {
    SidebarMenu,
  },
}
</script>
<style lang="scss">

  @import '../scss/variables';
  
  .title-panel  {
    color:white;
    text-align:center;
    padding:1em 0;
    h2 {
      margin:0;
    }
    h3 {
      margin:0;
      color:rgba($suez-white, .5);
    }
    hr {
      width:80%;
      border-color:rgba($suez-white, .5); 
    }
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?3f7780f0